export type AbhaSuccessCardVariant = 'hideAbhaNumber' | 'showAbhaNumber'

export const DEFAULT_ABHA_SUCCESS_CARD_VARIANT: AbhaSuccessCardVariant = 'hideAbhaNumber'

export const resolveAbhaSuccessCardVariant = (value?: string): AbhaSuccessCardVariant =>
  value === 'showAbhaNumber' ? 'showAbhaNumber' : 'hideAbhaNumber'
